import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { selectAuth } from '../../authNew/authSlice';
import { BaseCard, BasePageContainer, BaseComponentContainer, BaseVerticalContainer } from '../../../common/viewBaseComponents';

// Renders the authenticated user's settings overview and logout action.
export function UserSettings() {
    const navigate = useNavigate();
    const auth = useSelector(selectAuth);

    return (
        <BasePageContainer className={'w-11 flipleft'}>
            <BaseComponentContainer>
                <h3>User Settings</h3>
                <BaseVerticalContainer>
                    <BaseCard>
                        <div className='font-light'>User</div>
                        <div>{auth.displayName}</div>
                    </BaseCard>
                    <BaseCard>
                        <div className='font-light'>Email</div>
                        <div>{auth.email}</div>
                    </BaseCard>
                    <BaseCard>
                        <div className='font-light'>Logout</div>
                        <div>
                            <Button onClick={() => navigate('/logout')} label='Logout'></Button>
                        </div>
                    </BaseCard>
                </BaseVerticalContainer>
            </BaseComponentContainer>
        </BasePageContainer>
    );
}
